import { UserService } from '@/app/services';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-nav-links',
  imports: [RouterLink],
  templateUrl: './nav-links.component.html',
  styleUrl: './nav-links.component.scss',
})
export class NavLinksComponent {
  readonly year: number = new Date().getFullYear();

  constructor(
    private router: Router,
    private userService: UserService,
  ) {}

  public handleLoginClick(event: MouseEvent) {
    event.stopPropagation();

    if (event.altKey) {
      this.router.navigate(['/login'], { queryParams: { firstech: true } });
    } else {
      this.userService.login();
    }
  }
}
